import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { postSubscribeUnlock } from 'tpm-lib/post-unlock.js';

export class NewsletterInArticle extends Widget {
	componentWillMount() {
		this.handleEmail = this.handleEmail.bind(this);
		this.handleCheckbox = this.handleCheckbox.bind(this);
		if (
			this.props.category !== "morning-memo" &&
			this.props.category !== "where-things-stand"
		) {
			this.getData();
		}
	}

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const addToMultipleLists = urlParams.get("addToMultipleLists");
		if (addToMultipleLists) {
			this.postData({
				addToMultipleLists,
				nextPath: encodeURIComponent(window.location.pathname),
			});
		}
	}

	clearErrors() {
		this.setState({ errors: null });
	}

	getData() {
		this.request("GET");
	}

	postData(opts) {
		this.clearErrors();
		this.request("POST", opts);
	}

	request(method, data = {}) {
		const self = this;

		let params = `?`;
		Object.keys(data).forEach((k) => {
			params += `${k}=${data[k]}&`;
		});

		fetch(
			`https://accounts.${document.location.hostname}/doesspress/email-list${params}`,
			{
				method: `${method}`,
				credentials: "include",
			}
		)
			.then((r) => {
				return r.json();
			})
			.then((r) => {
				if (method === "GET") {
					// console.log(r.bindings);
					self.setState(
						{
							emailLists: r.bindings.emailLists,
							ident: r.bindings.ident,
						},
						() => {
							// console.log(self.state);
						}
					);
				} else {
					if (r.errors) {
						self.setState({ error: r.errors[0] });
					}
					if (r.confirmation) {
						// Post-subscribe unlock: shared transition (in-place content
						// swap when a token was minted; reload fallback otherwise).
						postSubscribeUnlock(r.confirmation, data);
						self.setState({ confirmation: r.confirmation });
					}
				}
			});
	}

	handleCheckbox(e) {
		const signedIn = this.state.ident.id;
		if (!signedIn) return;

		const opts = {
			listId: document.querySelector(
				'.NewsletterInArticle__Form input[name="listId"]'
			).value,
		};
		//always set opts.addToList = true, this form never unsubs anyone
		opts.addToList = true;

		this.postData(opts);
	}

	handleEmail(e) {
		e.preventDefault();
		debugger;

		const checkedInputs = document.querySelectorAll(
			".js_newsletter-checkbox:checked"
		);
		if (checkedInputs.length === 0) {
			this.setState({
				error: { message: "Please select a newsletter to subscribe to" },
			});
			return;
		} else {
			this.setState({
				error: null,
			});
		}

		const listIds = Array.from(checkedInputs).map(
			(input) =>
				document.querySelector(
					'.NewsletterInArticle__Form input[name="listId"]'
				).value
		);

		const opts = {
			addToMultipleLists: listIds.join(","),
			email: document.querySelector("#newEmail").value,
			nextPath: encodeURIComponent(window.location.pathname),
		};

		console.log(opts);

		this.postData(opts);
	}

	listDescription(list) {
		if (list.slug === "the-weekender") {
			return (
				<div>
					Unpack the funny, surreal, and strange in U.S. politics and culture with <b>Allegra Kirkland, Derick Dirmaier and the TPM team</b>.
				</div>
			);
		}

		if (list.slug === "the-franchise") {
			return (
				<div>
					<b>This is The Franchise newsletter.</b> What you need to know about
					the assault on voting rights and democracy in America, brought to you
					weekly by TPM reporter Khaya Himmelman.
				</div>
			);
		}

		if (list.slug === "the-backchannel") {
			if (this.props.membership && this.props.membership === "1")
				return (
					<div>
						<b>This is The Backchannel newsletter.</b> Josh Marshall's direct
						line for insight, analysis, and conversation. TPM members receive
						one must-read daily.
					</div>
				);

			return (
				<div>
					<b>This is The Backchannel newsletter.</b> Josh Marshall's direct line
					for insight, analysis, and conversation. Non-members can subscribe to
					the free edition and receive one must-read from Josh weekly.
				</div>
			);
		}

		return "";
	}

	renderCheckboxForm(list) {
		if (list.subscribed) return;

		if (this.state.confirmation) {
			return (
				<div className="NewsletterInArticle__Form --row">
					<div className="NewsletterInArticle__Description --inline-children">
						<span
							className="NewsletterInArticle__Button --bold"
							style="pointer-events: none; color: #333;"
						>
							You're Subscribed
						</span>
						<br />
						<p>
							Manage your subscriptions in the{" "}
							<a href="https://accounts.talkingpointsmemo.com/account#email">
								account panel <Icon name="right-long" style="light" />
							</a>
						</p>
					</div>
				</div>
			);
		}

		return (
			<div className="NewsletterInArticle__Form --row">
				<input type="hidden" name="listId" value={list.id} />
				<input
					className="js_newsletter-checkbox standalone"
					id={`id_${list.id}`}
					name="addToList"
					type="checkbox"
					defaultChecked={true}
					style={{ display: "none" }}
				/>

				<div className="NewsletterInArticle__Description --inline-children">
					{this.listDescription(list)}
					{!this.state.confirmation && (
						<span
							className="NewsletterInArticle__Button --bold"
							onClick={this.handleCheckbox}
						>
							Subscribe <Icon name="plus" style="light" />
						</span>
					)}
				</div>
			</div>
		);
	}


	renderEmailForm(list) {
		return (
			<div className="NewsletterInArticle__Form">
				<input type="hidden" name="listId" value={list.id} />
				<input
					className=" js_newsletter-checkbox"
					id={`id_${list.id}`}
					name="addToList"
					type="checkbox"
					defaultChecked={true}
					style={{ display: "none" }}
				/>
				<div className="NewsletterInArticle__Description">
					{this.listDescription(list)}
				</div>
				<div className="NewsletterInArticle__Flex">
					<label
						htmlFor={`id_${list.id}`}
						style={{
							position: "absolute",
							width: "1px",
							height: "1px",
							padding: 0,
							margin: "-1px",
							overflow: "hidden",
							clip: "rect(0,0,0,0)",
							border: 0,
						}}
					>
						Email Address
					</label>
					<input
						type="email"
						id="newEmail"
						pattern=".+@example\.com"
						required
						placeholder="Email Address"
					/>
					<div
						className="NewsletterInArticle__Button --min-w Button --transparent-to-red"
						onClick={this.handleEmail}
					>
						Subscribe
					</div>
				</div>
			</div>
		);
	}

	categoryToList(category) {
		const lists = this.state.emailLists;

		if (category === "the-weekender") {
			return lists.find((list) => list.slug === "the-weekender");
		}

		if (category === "the-franchise") {
			return lists.find((list) => list.slug === "the-franchise");
		}

		if (category === "the-backchannel") {
			return lists.find((list) => list.slug === "the-backchannel");
		}
		return null;
	}

	renderContent() {

		if (
			!["the-weekender", "the-franchise", "the-backchannel"].includes(
				this.props.category
			)
		) {
			return;
		}

		if (this.state.error && !this.state.emailLists) return;

		if (!this.state.emailLists) return;

		const signedIn = this.state.ident.id;
		const confirmAcctCreation = this.state.confirmation && !signedIn;
		const theList = this.categoryToList(this.props.category);

		if (signedIn && theList && theList.subscribed) return;

		return (
			<div className={`NewsletterInArticle__Inner`}>
				{!confirmAcctCreation && !signedIn && this.renderEmailForm(theList)}

				{confirmAcctCreation && (
					<div className="NewsletterInArticle__Confirmation">
						<h4>Check your inbox!</h4>
						<p>{this.state.confirmation.message}</p>
						<p>
							Don’t see an email? Please check your spam folder or{" "}
							<a href="https://talkingpointsmemo.com/contact">
								contact&nbsp;us
							</a>{" "}
							for assistance.
						</p>
					</div>
				)}

				{signedIn && this.renderCheckboxForm(theList)}

				{this.state.error && (
					<p
						style={{
							background: "#ffefb0",
							padding: "10px",
						}}
					>
						{this.state.error.message}
					</p>
				)}
			</div>
		);
	}
}
